import React from 'react';
import { Chip } from '@common-ui-library/atom';

import { EntityNameMappingType, UserManagementEntityType, Role, DropdownOption } from './types';
import { ROLES, ALLOWED_PROFESSION_IDS } from './constants';
export const APP_NAME = 'admin';
export const BASE_URL = `/${APP_NAME}/`;

export const isRootPath = (path: string) => {
  return /^\/admin\/$/.test(path); //|| /^\/?$/.test(path);
};

export const EntityNameMapping: EntityNameMappingType = {
  [UserManagementEntityType.PROVIDERS]: 'Users',
  [UserManagementEntityType.SITES]: 'Sites',
};

export const isValidEntity = (entity: string) => {
  return Object.values(UserManagementEntityType).includes(
    entity as UserManagementEntityType
  );
};

export const chipRole = (): Partial<Record<string, React.ReactNode>> => ({
  [ROLES.ELEOS_ADMINPORTAL_ADMIN]: (
    <Chip
      label="Admin"
      size="small"
      sx={{ height: '20px', fontSize: '0.75rem' }}
    />
  ),
});

// Check if user has a specific role
export const roleState = (roles: any, roleId: string) => {
  return roles?.some((r: any) => r.roleId === roleId && r.hasAccess === true) ?? false;
};

export const isEleosAdmin = (roles: any) => {
  return roleState(roles, ROLES.ELEOS_ADMINPORTAL_ADMIN);
};

export const adminChip = (roles: any) => {
  const isAdmin = isEleosAdmin(roles);

  return isAdmin && chipRole()[ROLES.ELEOS_ADMINPORTAL_ADMIN];
};

/**
 * Transforms the admin role checkbox value into the roles array format expected by the API.
 * - If existing roles exist, updates the admin role's hasAccess value
 * - If no existing roles, creates a new array with the admin role
 * - Returns undefined if no transformation is needed
 */
export const transformAdminRole = (
  existingRoles: Role[] | undefined,
  adminRole: boolean | undefined
): Role[] | undefined => {
  if (existingRoles === undefined && adminRole === undefined) {
    return undefined;
  }

  if (existingRoles) {
    return existingRoles.map((role) =>
      role.roleId === ROLES.ELEOS_ADMINPORTAL_ADMIN
        ? { ...role, hasAccess: adminRole ?? false }
        : role
    );
  }

  return [{ roleId: ROLES.ELEOS_ADMINPORTAL_ADMIN, hasAccess: adminRole ?? false }];
};

/** Extract error message from API error response */
export const extractErrorMessage = (
  error: unknown,
  fallback = 'An error occurred. Please try again.'
): string => {
  const err = error as { response?: { data?: { detail?: string } }; message?: string };
  return err?.response?.data?.detail || err?.message || fallback;
};

/** Filter profession choices to only allowed values */
export const filterProfessionChoices = (
  choices: DropdownOption[] | undefined
): DropdownOption[] => {
  if (!choices) return [];
  return choices.filter((choice) => 
    ALLOWED_PROFESSION_IDS.includes(choice.value as any)
  );
};

/** Filter timezone choices to US only for better UX */
export const filterTimezoneChoices = (
  choices: DropdownOption[] | undefined
): DropdownOption[] => {
  if (!choices) return [];
  return choices.filter((choice) => choice.value.startsWith('US/'));
};
